import { action, noop } from '@reatom/framework'

export const relationViewEvent = action(noop, 'relationViewEvent')
